import { CelestrakColorScheme } from './color-schemes/celestrak-color-scheme';
import { ConfidenceColorScheme } from './color-schemes/confidence-color-scheme';
import { CountryColorScheme } from './color-schemes/country-color-scheme';
import { GpAgeColorScheme } from './color-schemes/gp-age-color-scheme';
import { MissionColorScheme } from './color-schemes/mission-color-scheme';
import { ObjectTypeColorScheme } from './color-schemes/object-type-color-scheme';
import { OrbitalPlaneDensityColorScheme } from './color-schemes/orbital-plane-density-color-scheme';
import { RcsColorScheme } from './color-schemes/rcs-color-scheme';
import { ReentryRiskColorScheme } from './color-schemes/reentry-risk-color-scheme';
import { SmallSatColorScheme } from './color-schemes/smallsat-color-scheme';
import { SourceColorScheme } from './color-schemes/source-color-scheme';
import { SpatialDensityColorScheme } from './color-schemes/spatial-density-color-scheme';
import { StarlinkColorScheme } from './color-schemes/starlink-color-scheme';
import { SunlightColorScheme } from './color-schemes/sunlight-color-scheme';
import { VelocityColorScheme } from './color-schemes/velocity-color-scheme';
import { VisualMagnitudeColorScheme } from './color-schemes/visual-magnitude-color-scheme';

export const addonColorSchemes = [
  ObjectTypeColorScheme,
  CelestrakColorScheme,
  CountryColorScheme,
  ReentryRiskColorScheme,
  RcsColorScheme,
  MissionColorScheme,
  ConfidenceColorScheme,
  OrbitalPlaneDensityColorScheme,
  SpatialDensityColorScheme,
  SunlightColorScheme,
  GpAgeColorScheme,
  SourceColorScheme,
  VelocityColorScheme,
  StarlinkColorScheme,
  SmallSatColorScheme,
  VisualMagnitudeColorScheme,
];
